import { render, staticRenderFns } from "./ViewAdminPromotion.vue?vue&type=template&id=69f460c0&scoped=true"
import script from "./ViewAdminPromotion.vue?vue&type=script&lang=ts"
export * from "./ViewAdminPromotion.vue?vue&type=script&lang=ts"
import style0 from "./ViewAdminPromotion.vue?vue&type=style&index=0&id=69f460c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f460c0",
  null
  
)

export default component.exports